fragment InboxUserFragment on User {
    id
    name
    initials
    avatarUrl
}
